import React from "react";
// import * as IMAGES from "../Images";

import "./ZeroErrorState.css";

class ZeroErrorState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    return (
      <div className="zero-container">
        <img src="/cytocon-newlogo.png" alt="Zero State" style={{ width: "300px" }} />
        <div className="zero-content">{this.props.message}</div>
      </div>
    );
  };
}

export default ZeroErrorState;
